import React from 'react';
import styled from 'styled-components';
import UsageAndPrice from 'components/UsageAndPrice';
import BodyText from 'components/widget/BodyText';

export default styled(
  ({
    title, subTitle, description, price, className,
  }) => (
    <div className={className}>
      <UsageAndPrice
        usage={title}
        price={{
          currency: price.currency,
          price: price.price,
          frequency: price.frequency,
          small: true,
        }}
      />
      <BodyText>{subTitle}</BodyText>
      <p className="description">{description}</p>
    </div>
  ),
)`
  margin-left: ${({ theme }) => theme.spacing * 2}px;
  h2 {
    margin: 0 0 ${({ theme }) => theme.spacing}px;
  }
  .description {
    color: ${({ theme }) => theme.palette.grey[3]};
    margin: ${({ theme }) => theme.spacing}px 0 0;
  }
  p {
    color: inherit;
  }
`;
